import Collection from '../utils/Collection';

import { ONLINE_STATUS_CHANGED } from '../actions/onlineStatus';

import { FETCH_CONVERSATIONS_SUCCEEDED } from '../actions/conversation';

import {
  FETCH_TIMESLOT_STATUSES_SUCCEEDED,
  FETCH_TIMESLOT_STATUSES_BY_TUTOR_SUCCEEDED,
} from '../actions/timeslot';

const initialState = {
  onlineStatuses: [],
};

export default function onlineStatusReducer(state = initialState, action) {
  const { payload, type } = action;
  switch (type) {
    case FETCH_CONVERSATIONS_SUCCEEDED:
    case FETCH_TIMESLOT_STATUSES_SUCCEEDED:
      return {
        ...state,
        onlineStatuses: Collection.updateMany(
          state.onlineStatuses,
          payload.online_statuses,
        ),
      };
    case FETCH_TIMESLOT_STATUSES_BY_TUTOR_SUCCEEDED:
    case ONLINE_STATUS_CHANGED:
      return {
        ...state,
        onlineStatuses: Collection.update(
          state.onlineStatuses,
          payload.online_status.id,
          payload.online_status,
        ),
      };
    default:
      return state;
  }
}
